/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HospitalMessage } from './HospitalMessage';
import {
    HospitalMessageFromJSON,
    HospitalMessageFromJSONTyped,
    HospitalMessageToJSON,
    HospitalMessageToJSONTyped,
} from './HospitalMessage';

/**
 * 
 * @export
 * @interface FindAllHospitalMessagesSync200Response
 */
export interface FindAllHospitalMessagesSync200Response {
    /**
     * 
     */
    data?: Array<HospitalMessage>;
}

/**
 * Check if a given object implements the FindAllHospitalMessagesSync200Response interface.
 */
export function instanceOfFindAllHospitalMessagesSync200Response(value: object): value is FindAllHospitalMessagesSync200Response {
    return true;
}

export function FindAllHospitalMessagesSync200ResponseFromJSON(json: any): FindAllHospitalMessagesSync200Response {
    return FindAllHospitalMessagesSync200ResponseFromJSONTyped(json, false);
}

export function FindAllHospitalMessagesSync200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHospitalMessagesSync200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(HospitalMessageFromJSON)),
    };
}

export function FindAllHospitalMessagesSync200ResponseToJSON(json: any): FindAllHospitalMessagesSync200Response {
    return FindAllHospitalMessagesSync200ResponseToJSONTyped(json, false);
}

export function FindAllHospitalMessagesSync200ResponseToJSONTyped(value?: FindAllHospitalMessagesSync200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(HospitalMessageToJSON)),
    };
}

